import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularCheckmark, IconSolidInfo } from '@notino/react-styleguide';

import { wishlistMessages } from '../messages';

import { LinkInput, Message } from './styled';

interface IWishlistLinkProps {
  hostUrl: string;
  anonymousId: string;
  isCopySuccessful: boolean;
}

export const WishlistLink: React.FC<IWishlistLinkProps> = ({
  hostUrl,
  anonymousId,
  isCopySuccessful,
}) => (
  <>
    <LinkInput
      type="text"
      id="wishlist-link"
      readOnly={true}
      value={`${hostUrl}/wishlist?id=${anonymousId}`}
    />
    {isCopySuccessful ? (
      <Message color="text.positive">
        <IconRegularCheckmark height="18" color="icon.positive" />{' '}
        <FormattedMessage {...wishlistMessages.clipboard} />
      </Message>
    ) : (
      <Message color="text.negative">
        <IconSolidInfo height="12" color="icon.negative" />{' '}
        <FormattedMessage {...wishlistMessages.clipboardFail} />
      </Message>
    )}
  </>
);
